import React from "react";
import { Fade } from "react-reveal";
import Button from "../../components/button/Button";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import { greeting } from "../../portfolio";
import "./Greeting.css";
// import FeelingProud from "./FeelingProud";

export default function Greeting(props) {
  const theme = props.theme;

  return (
    <Fade bottom duration={2000} distance="40px">
      {/* <div className="greeting-wrapper"> */}
      <div className="greet-main" id="greeting">
        <div className="greeting-main">
          <div className="greeting-text-div">
            <div>
              <h1 className="greeting-text" style={{ color: theme.text }}>
                {greeting.title}
              </h1>
              {greeting.nickname && (
                <h2 className="greeting-nickname" style={{ color: theme.text }}>
                  {greeting.nickname}
                </h2>
              )}
              <p
                className="greeting-text-p subTitle"
                style={{ color: theme.secondaryText }}
              >
                {greeting.subTitle}
              </p>
              <SocialMedia theme={theme} />
              {greeting.resumeLink && (
                <div className="portfolio-repo-btn-div">
                  <Button
                    text="📝 My CV"
                    newTab={true}
                    href={greeting.resumeLink}
                    theme={theme}
                    className="portfolio-repo-btn"
                  />
                </div>
              )}
              {greeting.portfolio_repository && (
                <div className="portfolio-repo-btn-div">
                  <Button
                    text="⭐ Star Me On Github"
                    newTab={true}
                    href={greeting.portfolio_repository}
                    theme={theme}
                    className="portfolio-repo-btn"
                  />
                </div>
              )}
              {/* <div className="button-greeting-div">
              <Button text="Contact me" href="#contact" />
              <Button text="See my resume" newTab={true} href={greeting.resumeLink} />
            </div> */}
            </div>
          </div>
          <div className="greeting-image-div">
            <div className="greeting-video-wrapper">
              <video
                src="/videos/header-vid.mp4"
                autoPlay
                loop
                muted
                className="greeting-video"
              />
              <div
                className="greeting-video-overlay"
                style={{ boxShadow: `inset 0 0 8px 8px ${theme.body}` }}
              >
                <Button
                  text="Watch showcase video"
                  href="/#demo-reel"
                  theme={theme}
                />
              </div>
            </div>
            {/* <img
							alt="saad sitting on table"
							src={require("../../assets/images/feelingProud.svg")}
						></img> */}
            {/* <FeelingProud theme={theme} /> */}
            {/* <img alt="" src={require("../../assets/images/home-bg.png")}/> */}
          </div>
        </div>
      </div>
      {/* </div> */}
    </Fade>
  );
}
